import styled from "styled-components";

import { colorsPalettes, rgba, setFontVariant } from "@similarweb/styles";

export const StyledLoaderOverlay = styled.div`
    position: absolute;
    inset: 0;
    pointer-events: none;
    z-index: 1;
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 14px;
    background-color: ${colorsPalettes.carbon[0]};
    border: 1px solid ${colorsPalettes.midnight[50]};
    border-radius: 3px;
`;

export const StyledEditorContainer = styled.div<{ isDisabled?: boolean }>`
    display: block;
    position: relative;
    width: 100%;
    height: 100%;

    .ql-editor {
        box-sizing: border-box;
        padding: 8px;
        margin: 0;
        height: 100%;
        overflow-y: scroll;
        ${setFontVariant("input2", colorsPalettes.carbon[400])}
        box-shadow: none;
        border: 1px solid ${colorsPalettes.midnight[50]};
        border-radius: 3px;

        &:focus,
        &:focus-visible {
            outline: none;
            box-shadow: 0 3px 5px 0 ${rgba(colorsPalettes.carbon[500], 0.12)};
            border-color: ${colorsPalettes.blue[400]};
        }
        &::-webkit-scrollbar {
            width: 7px;
        }
        &::-webkit-scrollbar-thumb {
            background: ${colorsPalettes.carbon[200]};
            border-radius: 3px;
        }
        &::-webkit-scrollbar-track {
            border-radius: 10px;
            background: ${colorsPalettes.carbon[0]};
        }
        &::-webkit-resizer {
            display: none;
        }

        img {
            display: block;
            width: 100%;
            max-width: 400px;
            height: auto;
        }

        img.ai-agent-email-image-compare {
            max-width: 300px;
        }
    }
`;
